import { h } from 'preact';
import { Mousewheel, Navigation } from 'swiper';
import { Swiper as _Swiper, SwiperSlide } from 'swiper/react';

/**
 * A wrapper around Swiper to simplify module configuration
 *
 * @example
 * ```jsx
 * <Swiper navigation={swiperNavConfig} scrollable slidesPerView={3}>
 *  <SwiperSlide>Slide 1</SwiperSlide>
 *  <SwiperSlide>Slide 2</SwiperSlide>
 * </Swiper>
 * ```
 */
function Swiper({
  children,
  scrollable = false,
  navigation = false,
  ...props
}) {
  return (
    <_Swiper
      {...props}
      modules={[scrollable && Mousewheel, navigation && Navigation].filter(
        Boolean,
      )}
      mousewheel={scrollable}
      navigation={navigation}
    >
      {children}
    </_Swiper>
  );
}

export { Swiper, SwiperSlide };
